import { Image, RichText } from '@sitecore-jss/sitecore-jss-react';
import React from 'react';
import InputWithButton from '../InputWithButton';
import clsx from 'clsx';
import './style.scss';
import GenericPlaceholder from '../Shared/components/GenericPlaceholder/index.js';

const PageBannerComponent = (props) => {
  if (!props?.fields || !props.params)
    return <GenericPlaceholder componentName="PageBannerComponent" />;
  const { fields, params } = props;
  const { image, heading, text, link, emailPlaceholderText } = fields;

  const shouldRenderHeading = !!heading?.value;
  const shouldRenderText = !!text?.value;
  const shouldRenderPlaceholder = !!emailPlaceholderText?.value;
  const shouldRenderButton = !!link?.value?.href;
  const shouldRenderImage = !!image?.value?.src;

  return (
    <div className={clsx('page-banner content', 'add-margins', params?.Styles)}>
      <div className="inner">
        {shouldRenderImage && (
          <figure>
            <Image field={image} />
          </figure>
        )}
        <div className="content-wrap flex-it flex-justify-center flex-align-item-center">
          <div className="auto">
            {shouldRenderHeading && (
              <div className="title">
                <RichText field={heading} />
              </div>
            )}
            {shouldRenderText && (
              <div className="description">
                <RichText field={text} />
              </div>
            )}
            {shouldRenderPlaceholder && shouldRenderButton && (
              <InputWithButton button={link} placeholder={emailPlaceholderText} />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PageBannerComponent;
